var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#8060c3",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16 30c7.72 0 14-6.28 14-14s-6.28-14-14-14-14 6.28-14 14 6.28 14 14 14zm0-26c6.62 0 12 5.38 12 12s-5.38 12-12 12-12-5.38-12-12 5.38-12 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 15h12c.5527 0 1-.4478 1-1s-.4473-1-1-1h-10.1313l.9634-1.4453c.3062-.4595.1821-1.0806-.2773-1.3867-.4604-.3071-1.0811-.1826-1.3867.2773l-2 3c-.2046.3066-.2236.7012-.0498 1.0264.1742.3252.513.5283.8817.5283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 19h10.1318l-.9639 1.4453c-.3066.4595-.1826 1.0806.2773 1.3867.171.1138.3634.168.5538.168.3232 0 .6406-.1563.833-.4453l2-3c.2041-.3066.2236-.7012.0498-1.0264s-.5127-.5283-.8818-.5283h-12c-.5522 0-1 .4478-1 1s.4478 1 1 1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTransaction);
export default __webpack_public_path__ + "static/media/total-transaction.c4f92b55884ab8ce6a0949be286a59d0.svg";
export { ForwardRef as ReactComponent };